import { AreaEnum, AreaLabelsMap } from "@workflow/types";

/** Opções de área (multi-select) — todas as áreas do sistema com rótulo humano. */
export const areaOptions: { value: string; label: string }[] = Object.entries(AreaLabelsMap)
  .map(([value, label]) => ({ value, label }))
  .sort((a, b) => a.label.localeCompare(b.label, "pt-BR"));

/** Rótulo humano de uma área (cai no próprio código se for desconhecida). */
export const areaLabel = (area: string): string => AreaLabelsMap[area as AreaEnum] ?? area;
